import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ExternalLink from './Link/ExternalLink';

const findAnchorTag = /<a(.*?)href="http(.*?)"(.*?)>(.*?)<\/a>/g;

const DisplayHtmlContent = ({ html }) => {
    // Split the string by closing paragraph tags
    let strippedHTML = html.split("</p>");
    // Join it back up with line breaks to preserve them
    strippedHTML = strippedHTML.join("<br />");
    // Remove the opening paragraph tags
    strippedHTML = strippedHTML.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "");

    // Split the string if we find anchor tags
    // This splits the string into 5 parts
    // 0: The text leading up to the anchor tag
    // 1: [Empty]
    // 2: The URL, minus "http". Can still include the "s" and "://"
    // 3: [Empty]
    // 4: The anchor tag text
    const contentArray = strippedHTML.split(findAnchorTag);

    // Define the return array
    const result = [];

    // Let's loop over the places we found anchor tags
    for (let ii = 0; ii < contentArray.length; ii += 5) {
        // Grab the URL from the array of content
        let url = `http${get(contentArray, `[${ii + 2}]`, '#')}`;
        let isInternalUrl = false;

        // Update any internal tags
        url = url.replace(/(.*?).recreation.gov\/(.*?)\.pdf/, (m, $1, $2) => {
            isInternalUrl = true;
            return `${process.env.CDN_ROOT}/${$2}.pdf`;
        });

        // Push the regular text
        result.push(
            <span key={`prefix-${ii}`} dangerouslySetInnerHTML={{ __html: contentArray[ii] }} />
        );

        // If this is an internal URL, we want it to open in a new window
        if (isInternalUrl) {
            result.push(
                <a
                    key={`link-${ii}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={url}
                    alt={get(contentArray, `[${ii + 4}]`, '')}>
                    {get(contentArray, `[${ii + 4}]`, '')}
                </a>
            );
        }
        // If this is an external URL, and there is content, we want to show the warning modal
        else if (contentArray[ii+4] !== undefined){
            result.push(
                <ExternalLink
                    key={`link-${ii}`}
                    url={url}
                    altText={get(contentArray, `[${ii + 4}]`, '')}>
                    {get(contentArray, `[${ii + 4}]`, '')}
                </ExternalLink>);
        }
    }

    return (
        <p>
            {result}
        </p>
    );
};

DisplayHtmlContent.propTypes = {
    html: PropTypes.string
};

DisplayHtmlContent.defaultProps = {
    html: ''
};

export default DisplayHtmlContent;
